var map = {
	"./ar.json": "usHx",
	"./az.json": "cD7E",
	"./be.json": "FzYe",
	"./bg.json": "pvJT",
	"./bn.json": "FsJ6",
	"./bs.json": "+KRY",
	"./ca.json": "vwEC",
	"./cs.json": "IzVD",
	"./da.json": "+s7M",
	"./de.json": "iTTb",
	"./el.json": "aZUt",
	"./en.json": "5sXA",
	"./es.json": "yoGg",
	"./et.json": "FSCv",
	"./fa.json": "lR95",
	"./fi.json": "USIH",
	"./fr.json": "efQY",
	"./gl.json": "s9/M",
	"./he.json": "+gCM",
	"./hi.json": "8S6q",
	"./hr.json": "FYNC",
	"./hu.json": "D2Nf",
	"./hy.json": "friT",
	"./id.json": "JQ7c",
	"./it.json": "aynA",
	"./ja.json": "Ntvh",
	"./ka.json": "YOrg",
	"./kk.json": "OxH1",
	"./ko.json": "4Pz+",
	"./ky.json": "/5SR",
	"./lt.json": "UKo1",
	"./lv.json": "T0Jb",
	"./mk.json": "Gsrl",
	"./mn.json": "iEdO",
	"./ms.json": "wma1",
	"./nb.json": "xAel",
	"./nl.json": "8wpW",
	"./nn.json": "k9Zd",
	"./pl.json": "30RJ",
	"./pt.json": "cgfg",
	"./ro.json": "+TLy",
	"./ru.json": "YBOp",
	"./sk.json": "sDVq",
	"./sl.json": "AE3W",
	"./sr.json": "Cjo4",
	"./sv.json": "9F4W",
	"./th.json": "S2bw",
	"./tr.json": "EeMq",
	"./uk.json": "crD8",
	"./ur.json": "T2TA",
	"./uz.json": "qYzX",
	"./vi.json": "na/0",
	"./zh.json": "yhRS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DWXX";


//////////////////
// WEBPACK FOOTER
// ./node_modules/i18n-iso-countries/langs ^\.\/.*\.json$
// module id = DWXX
// module chunks = 1